import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-notifications-menu',
    templateUrl: './notifications-menu.component.html',
    styleUrls: ['./notifications-menu.component.scss'],
    standalone: false
})
export class NotificationsMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
